// TODO ADD MULTIPLE VARIANT SEPARATELY
import type { IChipValueType } from "@components/atoms/chip/types";
import { IMspTypeEnum } from "@api/msp";

export const colors: Record<IChipValueType | "default", string> = {
  hospital: "#731DD8",
  clinic: "#48A9A6",
  "home-office": "#48A9A6",
  "ambulance-office": "#91818A",
  kiosk: "#C1666B",
  "virtual-hf": "#9893DA",
  airport: "#B6C649",
  "sport-center": "#2C4251",
  retail: "#3B60E4",
  cmo: "#EC91D8",
  "local-admin": "#564766",
  "super-admin": "#CCA829",
  patient: "#AB29CC",
  staff: "#CC2936",
  doctor: "#0C6291",
  "medical-service-provider-lab": "#C1666B",
  "medical-service-provider-drug": "#48A9A6",
  "medical-service-provider-image": "#F67E7D",
  "schedule-time": "#118AB2",
  "on-demand-time": "#06D6A0",
  "off-time": "#EF476F",
  "inactive-patient": "#F74B4A",
  inactive: "#F74B4A",
  active: "#61D215",
  pending: "#FEC101",
  "follow-up-visit": "#7209B7",
  "first-visit": "#D0288D",
  yes: "#61D215",
  no: "#E32322",
  nodata: "#f59e0b",
  default: "#D0288D",
  medicine: "#00ACB1",
  experiment: "#00ACB1",
  images: "#00ACB1",
  school: "",
  "e-consultant": "",
  "dr-to-dr-consultant": "",
  online_visit: "#295DE1",
  in_person_visit: "#61D215",
  guest: "#2FC988",
  admin: "#3AA3B0",
  unassigned: "#F74B4A",
  assigned: "#61D215",
  "no-detect": "#b91c1c",
  certain: "#61d215",
  possible: "#f59e0b",
  office: "#8c1d5c",
  [IMspTypeEnum.Drugstore]: "#48A9A6",
  [IMspTypeEnum.ImagingCenter]: "#F67E7D",
  [IMspTypeEnum.Laboratory]: "#C1666B",
};
